import { render } from "./CourtDecisionDialog.vue?vue&type=template&id=1968f254"
import script from "./CourtDecisionDialog.vue?vue&type=script&lang=js"
export * from "./CourtDecisionDialog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Sabir\\Downloads\\Subrogation-Progress\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__